module.exports = __webpack_public_path__ + "img/gsgc2903_2.7589384a.svg";